import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  Input,
} from "@angular/core";
import { StatusModel } from "../../../model/status.model";
import { FormControl, Validators, FormBuilder } from "@angular/forms";
import { PilaServices } from "../../../services/InformationPila.services";
import { FormPilaRq } from "../../../model/fromPilaRq";
import { PilaInformationModel } from "../../../model/PilaInformation.model";
import { environment } from "src/environments/environment";
import { DatePipe }from '@angular/common';

declare var grecaptcha: any;
@Component({
  selector: "app-datos",
  templateUrl: "./datos.component.html",
  styleUrls: ["./datos.component.css"],
})
export class DatosComponent implements OnInit {
  @ViewChild("recaptcha", { static: false }) recaptchaElement: ElementRef;

  @Input() conplanOccidente: boolean;

  errormsg: string;
  input: FormPilaRq = new FormPilaRq();
  captcha: boolean;
  billnumber: boolean;
  repuesta: StatusModel = new StatusModel();
  infoPlanilla: PilaInformationModel = new PilaInformationModel();
  infoPila: boolean;
  infoform: boolean = true;
  errorPila: boolean;
  public date = new Date();

  forma: FormControl;

  constructor(private planillaPila: PilaServices, private fb: FormBuilder, public datepipe: DatePipe) {
    this.crearFormulario();
  }

  crearFormulario() {
    this.forma = new FormControl("", [
      Validators.required,
      Validators.maxLength(10),
      Validators.minLength(9),
      Validators.pattern(/^[0-9]\d*$/),
    ]);
  }

  ngOnInit() {
    this.addRecaptchaScript();
  }

  executeImportantAction() {
    this.input.billNumber = this.forma.value;
    console.log(this.input.billNumber);
    console.log(this.input);
    this.cargarInput();
    const response = grecaptcha.getResponse();
    if (this.input.billNumber === "") {
      this.billnumber = true;
      return;
    }
    if (response.length === 0) {
      this.errormsg = "Recaptcha not verified. Please try again!";
      this.billnumber = false;
      this.captcha = true;
    } else {
      this.captcha = false;
      this.billnumber = false;
      this.planillaPila
        .getInformationPila(this.input)
        .subscribe((data: any) => {
          console.log(data);
          this.repuesta.RQUid = data.rqUID;
          this.repuesta.StatusCode = data.mstatus.statusCode;
          this.repuesta.ServerStatus = data.mstatus.serverStatusCode;
          this.repuesta.Severity = data.mstatus.severity;
          this.repuesta.StatusDesc = data.mstatus.statusDesc;
          this.repuesta.InvoiceNum = data.invoiceNum;
          this.repuesta.NIE = data.nie;
          if (data.mPayInformation != null) {
            this.infoPlanilla.fechaCorte = data.mPayInformation.fechaCorte;
            this.infoPlanilla.fechaRadicacion =
              data.mPayInformation.fechaRadicacion;
            this.infoPlanilla.fechaVencimiento =
              data.mPayInformation.fechaVencimiento;
            this.infoPlanilla.fechaPagoOportuno =
              data.mPayInformation.fechaPagoOportuno;
            this.infoPlanilla.convenio = data.mPayInformation.convenio;
            this.infoPlanilla.amount = data.mPayInformation.valor;
            this.infoPlanilla.amountType = data.mPayInformation.tipoValor;
            this.infoPlanilla.status = data.mPayInformation.estado;
            this.infoPlanilla.name = data.name;
            this.infoPlanilla.planilla = data.invoiceNum;
            this.repuesta.planilla = this.infoPlanilla;
          }
          if (this.repuesta.Severity === "INFO" && this.infoPlanilla != null) {
            this.infoPila = true;
          } else {
            this.errorPila = true;
          }
        });
    }
  }
  
  goToUrl(): void {
    if (!this.conplanOccidente) {
      window.location.assign("https://www.avvillas.com.co/");
    } else {
      window.location.assign("https://www.bancodeoccidente.com.co/");
    }
  }

  goToHome(): void {
    window.location.href = window.location.href; 
  }

  renderReCaptch() {
    // tslint:disable-next-line: no-string-literal
    window["grecaptcha"].render(this.recaptchaElement.nativeElement, {
      sitekey: environment.keySitio,
      callback: (response) => {
        console.log(response);
      },
    });
  }

  addRecaptchaScript() {
    window["grecaptchaCallback"] = () => {
      this.renderReCaptch();
    };

    (function (d, s, id, obj) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        obj.renderReCaptch();
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src =
        "https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&amp;render=explicit";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "recaptcha-jssdk", this);
  }

  cargarInput() {
    if (this.conplanOccidente) {
      this.input.bankId = "00010236";
    } else {
      this.input.bankId = "00010524";
    }

    this.input.channel = "15";
    this.input.clientDt = new Date().toString();
    this.input.rqUID = this.datepipe.transform(new Date(), 'yyMMddHHmm');
  }
}
